import { SpintrTypes } from "src/typings";
import axios from "axios";

export const startDeliverTrack = (event: SpintrTypes.InsightsType) => {
    axios.post("/api/v1/startdeliver/insights", { type: event }).catch(() => {/* noop */});
}